import { AppDatatableTreeStatus, AppDatatableActionType } from "../enums";
import { AppDatatableConfigOptions } from "../models";

export class AppBasicTableHelper {

    public static toParams(options: any = {}) : any {
        if(options && options.action && options.selected) {            
            //delete selected and actions
            delete options.action;
            delete options.selected;
        }

        return options;
    }

    public static toTreeParams(fromRelation: string, idProp: string, options: any = {}) : any {
        if(!options || (!options.action && !options.searchTerm)) {
            options["level"] = 1;
        } else if(options && options.action && (options.action == AppDatatableActionType.EXPAND) && options.selected) {
            options[fromRelation] = options.selected[0][idProp];
            //disable pagination for children
            options["pageSize"] = options.selected[0].childrenCount+1;
            delete options.pageIndex;
        }
        //delete selected and actions
        delete options.action;
        delete options.selected;

        return options;
    }
    
    public static toTreeRows(items: Array<any>, expandAllOnInit: boolean): Array<any> {
        for (let r of items) {
            if (r.childrenCount && r.childrenCount > 0) {
                r.treeStatus = expandAllOnInit ? AppDatatableTreeStatus.EXPANDED : AppDatatableTreeStatus.COLLAPSED;
            } else {
                r.treeStatus = AppDatatableTreeStatus.DISABLED;
            }
        }
        return items;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/basic/basic-table-helper.utils.ts